import React from "react";
import PropTypes from "prop-types";

const SmallCardWrapper = ({ name, children, OrderRemarksHistory }) => {
  return (
    <div className="border border-1 border-light-dark radius">
      <div className="bg-gray-700 p-5 radius bottom-left-radius-remove bottom-right-radius-remove">
        <h6 className="font-weight-bolder m-0 text-white">{name}</h6>
      </div>
      <div className={`mb-0 w-100 ${OrderRemarksHistory ? "" : "p-5"}`}>
        {children}
      </div>
    </div>
  );
};

SmallCardWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default SmallCardWrapper;
